import { render, staticRenderFns } from "./WorkflowReadOnlyModal.vue?vue&type=template&id=637f6f5a&scoped=true"
import script from "./WorkflowReadOnlyModal.vue?vue&type=script&lang=ts"
export * from "./WorkflowReadOnlyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f6f5a",
  null
  
)

export default component.exports